module.exports = "pegasus/assets/theme5/small/3.jpg";